import jsPDF from "jspdf";
import axios from "axios";
import JsBarcode from "jsbarcode";
import Select from "react-select";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import config from "../../../../config/config";
import { Badge } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../../common/UserPermission";
import { Noimage } from "../../../../common/imagePath";

let UpdateDataForBarcodeGeneration;

// update user permission data by login user id
export function updateDataForBarcodeGeneration(p_barcodedata) {
  UpdateDataForBarcodeGeneration = p_barcodedata;
}

// return only list of user permission data
export function GetDataForBarcodeGeneration() {
  return UpdateDataForBarcodeGeneration;
}

let barcodesheetdata;

const SearchableDropdown = ({ callback }) => {
  // console.log(customerID, "<===customerId 1155");
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  //const Clone = localStorage.getItem("Clone");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showRefresh, setShowRefresh] = useState(false);
  const [cursor, setcursor] = useState(0);

  // handleChange-
  const handleChange = () => {};

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);

      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${inputValue}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationID}&itemsearchtype=&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response.data.ResponseData.length > 0) {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              console.log("suggestions ==>",  data[0].QuickbookId);
            
              const itemarray = data[0].Itemnumber.split(",");
              if (data.length === 1 && itemarray.includes(inputValue)) {
                handleInputClick(
                  data[0].ItemId,
                  data[0].ItemName,
                  data[0].VariationName,
                  data[0].UnitPrice,
                  data[0].Itemquantity,
                  data[0].Description,
                  data[0].VariationId,
                  data[0].AttributeId,
                  data[0].Module,
                  data[0].CategoryID,
                  data[0].CategoryName,
                  data[0].CostPrice,
                  data[0].Itemnumber,
                  data[0].Allowaltdescription,
                  data[0].IsItemserialnumber,
                  data[0].VariationQuantity,
                  data[0].RecallPrice,
                  data[0].Tier1,
                  data[0].Tier2,
                  data[0].Tier3,
                  data[0].Tier4,
                  data[0].Tier5,
                  data[0].QuickbookId
                );
                // setTableData([...tableData,...data])
              } else {
                setSuggestions(data);
              }
            }
          }
          setShowRefresh(false);
        })

        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setShowRefresh(true);
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleKeyDown = (e) => {
    // e.preventDefault()
    console.log("log : e.keyCode =>", e.keyCode, e.key, e.target.value);

    console.log(suggestions,cursor, "suggestionsaa");

    if (e.keyCode === 13 || e.key === "Enter") {
      const item = suggestions[cursor];
      console.log(item,"7744");
      
      handleInputClick(
        item.ItemId,
        item.ItemName,
        item.VariationName,
        item.UnitPrice,
        item.Itemquantity,
        item.Description,
        item.VariationId,
        item.AttributeId,
        item.Module,
        item.CategoryID,
        item.CategoryName,
        item.CostPrice,
        item.Itemnumber,
        item.Allowaltdescription,
        item.IsItemserialnumber,
        item.VariationQuantity,
        item.RecallPrice,
        item.Tier1,
        item.Tier2,
        item.Tier3,
        item.Tier4,
        item.Tier5,
        item.QuickbookId
      );
    } else if (e.keyCode === 38 && cursor > 0) {
      setcursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      setcursor(cursor + 1);
    }

    // setTimeout(()=>{
    //   barcodeScan=""
    // },100)
  };

  // const handleToast = () => {
  //   if (readonly === true) {
  //     toastError("Please Select a Customer First");
  //   }
  // };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5,
    pQuickbookId

    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {});

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: item.VariationQuantity,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              ActualOnHand: parseInt(item.VariationQuantity),
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            }));

            setTableData([tablesDatas[0]]);
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: pItemQuantity,
        ItemCurrentQuantity: pItemQuantity, //pItemQuantity,
        ActualOnHand: parseInt(pItemQuantity),
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        QuickbookId : pQuickbookId
        // ItemKitId: pItemId
      };
      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);
  console.log(suggestions, "<========suggestions");

  return (
    <div className="container">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              {showRefresh ? (
                <i
                  style={{ color: "#FF9F43" }}
                  class="fa fa-refresh fa-spin"
                ></i>
              ) : (
                <Link to="/manage-items">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </Link>
              )}
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "500px", overflow: "auto" }}
            >
              {suggestions.map((item, index) => (
                <li
                  className="border-bottom"
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.CostPrice,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.RecallPrice,
                      item.Tier1,
                      item.Tier2,
                      item.Tier3,
                      item.Tier4,
                      item.Tier5,
                      item.QuickbookId

                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    // className="dropdown-item"
                    className={
                      cursor === index
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src = Noimage;
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle m-2"
                      width="55"
                      height="55"
                    />

                    <div className="customer-info">
                      <strong className="name word-break-data">
                        {item.ItemName}{" "}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                        <Badge
                          className="ml-auto"
                          variant="primary"
                          style={{ position: "absolute", right: "5px" }}
                        >
                          {item.Module}
                        </Badge>
                      </strong>
                      <div>
                        {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                        {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                        Selling Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.Itemquantity)}
                      </div>
                      <div>Categories: {item.CategoryName}</div>
                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};

const BarcodeLabel = (barcodeLabel) => {
  function barcodeLabelPopup() {
    barcodeLabel();
    const token = localStorage.getItem("Token");
  }

  const barcodeRefs = useRef([]);
  const [selectedId, setSelectedId] = useState([]);
  const [value, setValue] = useState([0]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      var g = document.getElementsByTagName(barcodeRef);
      const dataItemId = barcodeRef?.getAttribute("data-itemid");
      const barcodeValue = dataItemId;
      // const barcodeValue = `${index}`;
      const paddedBarcodeValue = barcodeValue?.padStart(data.zeroFill, "0"); // Zerofill at the barcode

      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 0,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  useEffect(() => {
    // setTimeout(function () {
    generateBarcodes(barcodesheetdata);
    // }, 2000);
  }, [value]);

  const refreshpage = () => {
    window.location.reload();
  };

  const downloadPdf = () => {
    generateBarcodes(barcodesheetdata);
    const pdf = new jsPDF();

    let yOffset = 10; // Initial y offset value
    let pageHeight = pdf.internal.pageSize.getHeight() - 10; // Get the page height

    barcodeRefs.current.forEach((barcodeRef, index) => {
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");

      const barcodeHeight = data.height; // Use 'data.height' instead of 'value * data.height'

      if (yOffset + barcodeHeight > pageHeight) {
        pdf.addPage(); // Add a new page if the barcode exceeds the remaining space on the current page
        yOffset = 10; // Reset the y offset for the new page
        pageHeight = pdf.internal.pageSize.getHeight() - 10; // Get the updated page height
      }

      // Print "Sonar POS" text above the barcode
      pdf.setFontSize(10);
      pdf.text("Sonar POS", 13, yOffset + 9);

      // Print the barcode image
      pdf.addImage(imgData, "PNG", 10, yOffset + 10); // Adjust the y coordinate as needed

      // Print "UnitPrice" and "VariationName" below the barcode
      const item = barcodesheetdata[index - 1];
      pdf.setFontSize(8);
      pdf.text(
        `$${parseFloat(item?.UnitPrice).toFixed(2)} ${item?.VariationName}`,
        8,
        yOffset + barcodeHeight + 4
      ); // Adjust the y coordinate as needed

      yOffset += barcodeHeight + 25; // Increment the y offset for the next barcode without spacing
    });

    pdf.save("barcodes.pdf");
    // window.location.reload(true);
  };

  console.log("barcodeSheetData::>>", barcodesheetdata, barcodeRefs);

  return (
    <>
      <div
        className="modal fade"
        id="BarcodeLabelModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-m modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Number of labels to skip</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <input
                    type="number"
                    className="form-control form-control-sm mb-4"
                    placeholder="Number of labels to skip"
                    onChange={(event) => setValue(event.target.value)}
                  ></input>
                </div>
                <div className="modal-footer justify-content-center">
                  <Link
                    to="#"
                    className="btn-primary btn btn-md text-align-center"
                    data-bs-dismiss="modal"
                    onClick={() => downloadPdf()}
                  >
                    Submit{" "}
                  </Link>
                </div>
                <div id="barcode-output" className="text-center">
                  {barcodesheetdata?.map((item, index) => (
                    <div key={item}>
                      <div key={item.AutoIncrementId} className="mb-4">
                        <div>Sonar POS</div>
                        <canvas
                          data-itemid={item.Id}
                          data-name={item.AutoIncrementId}
                          ref={(el) =>
                            (barcodeRefs.current[item.AutoIncrementId] = el)
                          }
                          id={`barcode-${item.AutoIncrementId}`}
                        />
                        <div>
                          ${parseFloat(item.UnitPrice).toFixed(2)}
                          {item.VariationName}
                          {/* &nbsp;&nbsp; */}
                        </div>
                        {/* <div></div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CloseFinishCountAndUpdateInventory = (
  { handleSubmit },
  closeFinishCountAndUpdateInventory
) => {
  function closeFinishCountAndUpdateInventoryPopUp() {
    closeFinishCountAndUpdateInventory();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="CloseFinishCountAndUpdateInventoryModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">
                Close Finish Count And Update Inventory
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p className="">
                    Are you sure you want to finish the inventory count ?
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("1");
                  closeFinishCountAndUpdateInventoryPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CloseFinishCountAndDoNotUpdateInventory = (
  { handleSubmit },
  closeFinishCountAndDoNotUpdateInventory
) => {
  function closeFinishCountAndDoNotUpdateInventoryPopUp() {
    closeFinishCountAndDoNotUpdateInventory();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="CloseFinishCountAndDoNotUpdateInventoryModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">
                Close Finish Count And Do Not Update Inventory
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p className="">
                    Are you sure you want to finish the inventory count?
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("2");

                  closeFinishCountAndDoNotUpdateInventoryPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ContinueCountLater = ({ handleSubmit }, continueCountLater) => {
  function continueCountLaterPopUp() {
    continueCountLater();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="ContinueCountLaterModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Continue Count Later</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <p className="">
                    Are you sure you want to finish the inventory count?
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("3");
                  continueCountLaterPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const NewInventoryCount = (props) => {
  const barcodeRefs = useRef([]);
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  // const [formValues, setFormValues] = useState();
  const [stateNew, setStateNew] = useState([]);
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState("Receive");
  const locationId = localStorage.getItem("Location");
  const [changeCount, setChangeCount] = useState([0]);
  const [changeComment, setChangeComment] = useState([]);
  const [checkStatus, setCheckStatus] = useState(true);
  const [statusData, setStatusData] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });
  const [depositToAccount, setDepositToAccount] = useState([]);
  console.log("depositToAccount 785", depositToAccount);
  const [supoptions, setSupOptions] = useState([]);
  const [accountquickbookid, setAccountQuickbookId] = useState(0);
  const [expensequickbookid, setExpenseQuickbookId] = useState(0);
  const [incomequickbookid, setIncomeQuickbookId] = useState(0);
  // const []

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };


  
  useEffect(() => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountdefaultitemaccount`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        // alert(JSON.stringify(res.data))
        const accountdata = res.data?.ResponseData[0];
        const incomedata = res.data?.ResponseData[1];
        const expensedata = res.data?.ResponseData[2];
       
        setIncomeQuickbookId(incomedata?.incomaccountQuickbookid);
        setExpenseQuickbookId(expensedata?.expenceaccountQuickbookIdid);
        setAccountQuickbookId(accountdata?.accountQuickbookid);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleCountChange = (event, index) => {
    let indexCount = [...changeCount];
    indexCount[index] = event.target.value;
    // console.log(index, indexCount);
    setStateNew((prev) => {
      const updatedData = [...prev];
      updatedData[index]["Counts"] = event.target.value;
      return updatedData;
    });

    setChangeCount(indexCount);
    console.log("changeCount ==> ", indexCount);
  };

  const handleCommentChange = (event, index) => {
    let indexComment = [...changeComment];
    indexComment[index] = event.target.value;
    // console.log(index, indexComment);

    setChangeComment(indexComment);
    // console.log("changeComment ==> ", changeComment);
  };
  const navigate = useNavigate();
 
  const handleSubmit = async (Status) => {
    console.log(stateNew,Status, "<===410501");


    const filterData = stateNew.map((el) => {
      if (el.AccountId > 0) {
        return {
          ...el,
          Counts:
            Number(el.Counts) < 0 ? Number(el.Counts) : Number(el.Counts) * -1,
        };
      }
      // If AccountId is not greater than 0, return the original object or handle it as needed
      return el;
    });

    const checkCountErr = stateNew.filter(
      (el) => el.Counts == undefined || el.Counts == 0 || el.Counts == "" 
    );

    // if(checkCountErr?.length > 0 || stateNew?.length < 1){
    //   toastError("Please Add Items and Increase Count");
    //   return
    // }
   

    // let paramObject.id;
    // return;
    if (!paramObject.id) {
      setLoading(true);
      axios
        .post(
          `${config.itemsBaseUrl}/items/countinventoryupsert`,
          {
            id: 0,
            loginuserid: Id,
            locationid: locationId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            // toastSuccess(SUCCESS_MESSAGE);
            for (let i = 0; i < filterData.length; i++) {
              filterData[i].Counts = changeCount[i];
              filterData[i].Comments = changeComment[i];
              filterData[i].AccountId = filterData[i].AccountId;
              filterData[i].SupplierId = filterData[i].SupplierId;
            }

            if (Status == "1") {
              console.log(Status, "Status====>1");
              console.log(filterData, "<===filterData 2");

              // let CountInventoryUpdate = filterData.filter(el=> el.VariationName !== "");

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = filterData;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );
              console.log(countinventoryupdatejsonstring, "<===filterData 3");

              localStorage.setItem("New", JSON.stringify(filterData));
              // return
              setLoading(true);
              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                    IncomeQuickbookId:incomequickbookid,
                    AccountQuickbookId:accountquickbookid,
                    ExpenseQuickbookId:expensequickbookid,
                    stateNew:stateNew
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 1 ==> ", res);
                  setLoading(false);
                  if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess(SUCCESS_MESSAGE);
                    // navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    navigate(`/item-count-invetory`);
                    setStatusData(1);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  setLoading(false);
                  // window.location.href = window.location.href;
                })
                .catch((error) => {
                  setLoading(false);
                  // console.log("error: ", error);
                });
            } else if (Status == "2") {
              // let CountInventoryUpdate = filterData.filter(function (
              //   countInventoryUpdate
              // ) {
              //   return countInventoryUpdate.VariationName !== "";
              // });

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = filterData;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );

              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                    IncomeQuickbookId:incomequickbookid,
                    AccountQuickbookId:accountquickbookid,
                    ExpenseQuickbookId:expensequickbookid,
                    stateNew:stateNew
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 2 ==> ", res);
                  setLoading(true);
                  if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess(SUCCESS_MESSAGE);
                    navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    setStatusData(2);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  // window.location.href = window.location.href;
                  setLoading(false);
                })
                .catch((error) => {
                  setLoading(false);
                  // console.log("error: ", error);
                });
            } else if (Status == "3") {
              // let CountInventoryUpdate = filterData.filter(function (
              //   countInventoryUpdate
              // ) {
              //   return countInventoryUpdate.VariationName !== "";
              // });

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = filterData;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );

              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                    IncomeQuickbookId:incomequickbookid,
                    AccountQuickbookId:accountquickbookid,
                    ExpenseQuickbookId:expensequickbookid,
                    stateNew:stateNew
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 3 ==> ", res);
                  setLoading(true);
                  if (
                    res.data.ResponseCode === "SUCCESS" &&
                    res.data.ResponseID > 0
                  ) {
                    toastSuccess(SUCCESS_MESSAGE);
                    navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    setStatusData(3);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  // window.location.href = window.location.href;
                  setLoading(false);
                })
                .catch((error) => {
                  setLoading(false);
                });
            } else {
              console.log("No Condition matched");
            }
            // console.log(res.data.ResponseID);
            // paramObject.id = res.data.ResponseID;
            // navigate(`/new-inventory-count/${res.data.ResponseID}`);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError("Name" + ALREADY_EXIST);
          } else {
            toastError(ERROR_MESSAGE);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          // console.log("error: ", error);
        });
    } else {
      for (let i = 0; i < filterData.length; i++) {
        filterData[i].Counts = changeCount[i];
        filterData[i].Comments = changeComment[i];
      }

      console.log(filterData, "countInventoryUpdate  check");
      if (Status == "1") {
        console.log(filterData, "countInventoryUpdate test");
        let CountInventoryUpdate = filterData.filter(function (
          countInventoryUpdate
        ) {
          return countInventoryUpdate.VariationName !== "";
        });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = CountInventoryUpdate;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );


        let res =  await  axios
        .post(
          `${config.itemsBaseUrl}/items/countinventoryupsert`,
          {
            id: 0,
            loginuserid: Id,
            locationid: locationId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        console.log(res,"1747");
        

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
              inventoryCountId: res.data.ResponseID,
              locationId: locationId,
              status: Status,
              loginUserId: Id,
              IncomeQuickbookId:incomequickbookid,
              AccountQuickbookId:accountquickbookid,
              ExpenseQuickbookId:expensequickbookid,
              stateNew:stateNew
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 1 ==> ", res);
            setLoading(true);
            if (res.data.ResponseCode === "SUCCESS") {
              toastSuccess(SUCCESS_MESSAGE);
              // navigate(`/new-inventory-count/${paramObject.id}`);
              navigate(`/item-count-invetory`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            setLoading(false);
            window.location.href = window.location.href;
          })
          .catch((error) => {
            setLoading(false);
            // console.log("error: ", error);
          });
      } else if (Status == "2") {
        let CountInventoryUpdate = filterData.filter(function (
          countInventoryUpdate
        ) {
          return countInventoryUpdate.VariationName !== "";
        });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = CountInventoryUpdate;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
                   // inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                    IncomeQuickbookId:incomequickbookid,
                    AccountQuickbookId:accountquickbookid,
                    ExpenseQuickbookId:expensequickbookid,
                    stateNew:stateNew
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 2 ==> ", res);
            setLoading(true);
            if (res.data.ResponseCode === "SUCCESS") {
              toastSuccess(SUCCESS_MESSAGE);
              navigate(`/new-inventory-count/${paramObject.id}`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            window.location.href = window.location.href;
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            // console.log("error: ", error);
          });
      } else if (Status == "3") {
        console.log("Sonu===>");
        // console.log(filterData,"filterData==>")
        // let CountInventoryUpdate = filterData.filter(function (
        //   countInventoryUpdate
        // ) {
        //   return countInventoryUpdate.VariationName !== "";
        // });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = filterData;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
                   // inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                    IncomeQuickbookId:incomequickbookid,
                    AccountQuickbookId:accountquickbookid,
                    ExpenseQuickbookId:expensequickbookid,
                    stateNew:stateNew
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 3 ==> ", res);
            setLoading(true);
            if (
              res.data.ResponseCode === "SUCCESS" &&
              res.data.ResponseID > 0
            ) {
              toastSuccess(SUCCESS_MESSAGE);
              navigate(`/new-inventory-count/${paramObject.id}`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            window.location.href = window.location.href;
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        console.log("No Condition matched");
      }
    }
  };

  const callback = (payload) => {
    console.log(payload,"410501");
    
    if (payload != undefined && payload.length > 0) {
      let newItem = { ...payload[payload.length - 1] };
      console.log(newItem, "newItem");
      console.log(stateNew, "stateNew12345");
      const existingItemIndex = stateNew.findIndex(
        (item) =>
          item.VariationName === newItem.VariationName &&
          item.VariationId === newItem.VariationId
      );
      console.log(existingItemIndex, "existingItemIndex===>");
      // if (existingItemIndex !== -1) {
      //   const existingItem = stateNew[existingItemIndex];

      //   existingItem.itemquantity = existingItem.itemquantity + 1;

      //   const updatedDataNew = [...stateNew];
      //   updatedDataNew[existingItemIndex] = existingItem;

      //   setStateNew(updatedDataNew);
      // } else {
      //   setStateNew([...stateNew, newItem]);
      // }

      newItem["Counts"] = 0;
      if (existingItemIndex == -1) {
        setStateNew([...stateNew, newItem]);
      }
    }
    // setStateNew(payload);
  };
  console.log("stateNew ==> ", stateNew);
  const handlebarcodesheet = () => {
    let transformedArray = [];
    stateNew.forEach((obj) => {
      for (let i = 0; i < obj.Counts; i++) {
        const newObj = {
          AutoIncrementId: transformedArray.length + 1,
          Id: obj.Id,
          VariationName: obj.VariationName,
          ItemId: obj.ItemId,
          CostPrice: obj.CostPrice,
          UnitPrice: obj.UnitPrice,
        };
        transformedArray.push(newObj);
      }
    });

    barcodesheetdata = transformedArray;

    // setFormValues(transformedArray);
  };

  const handleDeletePopup = (index) => {
    // const deleteRequestParam = {
    //   itemcountinventoryid: pID,
    // };
    // localStorage.setItem(
    //   "DeleteRequestParam",
    //   JSON.stringify(deleteRequestParam)
    // );
    // setDeleteModalOpen(true)
    const updateddata = [...stateNew];
    updateddata.splice(index, 1);
    setStateNew(updateddata);
  };

  console.log("stateNew 1270", stateNew);
  useEffect(() => {
    if (paramObject.id) {
      setLoading(true);
      axios
        .get(
          `${config.itemsBaseUrl}/items/countinventoryfindbyid?inventorycountid=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setStateNew(res.data.ResponseData.CountInventory);
          callback(stateNew);
          setCheckStatus(res.data.ResponseData.Status == 3 ? true : false);
          console.log("first", res.data.ResponseData);
          setStatusData(res.data.ResponseData.Status);

          res.data.ResponseData.CountInventory?.map((data, index) => {
            changeCount[index] = data.Counts;
          });
          res.data.ResponseData.CountInventory.map((data, index) => {
            changeComment[index] = data.Comments;
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log("Error ==> ", err);
          setLoading(false);
        });
      setLoading(false);
    }
  }, [props, paramObject.id > 0]);

  const location = useLocation();
  const sharedState = location?.state ? location?.state.dataToSend : "";
  // const newData = stateNew.concat(sharedState);
  console.log("Locationnnnnn", sharedState);

  // useEffect(() => {
  //   // const newData = [...stateNew, ...sharedState];

  //   if (stateNew && sharedState) {
  //     const mappedReceivingItems = sharedState?.map((item) => {
  //       const mappedItem = {
  //         ActualOnHand: item.ItemActualOnHand,
  //         Comments: "",
  //         CostPrice: item.CostPrice,
  //         Counts: item.Count,
  //         Id: item.Id,
  //         InventoryCountId: paramObject.id,
  //         ItemId: item.ItemId,
  //         UnitPrice: item.UnitPrice,
  //         VariationId: item.itemVariationId,
  //         VariationName: item.ItemName,
  //       };
  //       return mappedItem;
  //     });
  //     const combinedArray = [...stateNew, ...mappedReceivingItems];
  //     setStateNew(combinedArray);
  //   }
  // }, [sharedState]);
  useEffect(() => {
    if (stateNew && sharedState) {
      const mappedReceivingItems = sharedState?.map((item) => {
        const mappedItem = {
          ActualOnHand: item.ItemActualOnHand,
          Comments: "",
          CostPrice: item.CostPrice,
          Counts: item.Count,
          Id: item.Id,
          InventoryCountId: paramObject.id,
          ItemId: item.ItemId,
          UnitPrice: item.UnitPrice,
          VariationId: item.itemVariationId,
          VariationName: item.ItemName,
        };
        return mappedItem;
      });
      const combinedArray = [...stateNew, ...mappedReceivingItems];
      setStateNew((prev) => [...prev, ...mappedReceivingItems]);
    }
  }, [sharedState]);

  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
          };
          return mappedItem;
        });
        // setStateNew(mappedReceivingItems);
        setDepositToAccount(mappedReceivingItems);
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const options = supoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName,
    label:
      option.CompanyName +
      " (" +
      option.FirstName +
      " " +
      option.LastName +
      ")",
    email: option.Email,
    address: option.Address,
    balance: option.Balance,
    image: option.Image,
  }));

  console.log("options 1410", stateNew);

  const handleChangeInput = (event, index, fieldName) => {
    // console.log("inventory count 1408", event);
    if (fieldName == "InventoryAdjusmentAccount") {
      console.log(event?.value, index, fieldName, "inventory count 456");
      setStateNew((prev) => {
        const updatedData = [...prev];
        updatedData[index]["AccountId"] = event?.value;
        updatedData[index]["Counts"] =
          event?.value !== undefined
            ? Number(prev[index].Counts) > 0
              ? Number(prev[index].Counts) * -1
              : Number(prev[index].Counts)
            : Number(prev[index].Counts) * -1;

        console.log(prev[index].Counts, Number(prev[index].Counts), "01062024");
        return updatedData;
      });
      let indexCount = [...changeCount];
      indexCount[index] =
        event?.value !== undefined
          ? Number(indexCount[index]) > 0
            ? Number(indexCount[index]) * -1
            : Number(indexCount[index])
          : Number(indexCount[index]) * -1;
      setChangeCount(indexCount);
    } else if (fieldName == "Supplier") {
      setStateNew((prev) => {
        const updatedData = [...prev];
        updatedData[index]["SupplierId"] = event?.value;
        return updatedData;
      });
      console.log(event?.value, index, fieldName, "inventory count 456");
    } else if (fieldName == "EntryDate") {
      console.log(
        event?.target?.value,
        index,
        fieldName,
        "inventory count 456"
      );
    } else if (fieldName == "RefrenceNo") {
      console.log(
        event?.target?.value,
        index,
        fieldName,
        "inventory count 456"
      );
    }
  };

  console.log("stateNew, depositToAccount 1447", stateNew, depositToAccount);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Count Inventory</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item active">New Inventory Count</li>
              </ul>
            </div>
          </div>
          <div className="col-md-12 page-button mb-3">
            <div className="d-flex flex-wrap">
              {/* Items Not Counted & In Stock */}
              <div className="p-2">
              {checkUserPermission("/item-not-counted-and-in-stock/:id") ? (
                <Link
                  className="btn btn-sm btn-secondary"
                  to={`/item-not-counted-and-in-stock`}
                >
                  Items Not Counted &amp; In Stock
                </Link>
              ):(" ")}
              </div>
              {/* Items Not Counted */}
              <div className="p-2">
               {checkUserPermission("/item-not-counted/:id") ? (
                <Link
                  className="btn btn-sm btn-secondary"
                  to={`/item-not-counted`}
                >
                  Items Not Counted
                </Link>):(" ")}
              </div>
              {/* Barcode Labels */}
              
           
              {paramObject.id > 0 && (
              <div className="p-2">
              {checkUserPermission("/item-count-inventory-barcode-label/:id") ? (
                <Link
                  className="btn btn-sm btn-secondary"
                  to={`/item-count-inventory-barcode-label/${paramObject.id}`}
                  onClick={() => updateDataForBarcodeGeneration(stateNew)}
                >
                  Barcode Labels
                </Link>):(" ")}
              </div>
              )}
              {/* Barcode Sheet */}
              {paramObject.id > 0 && (
              <div className="p-2">
              {checkUserPermission("item-inventory-count-barcodesheet") ? (
                <button
                  className="btn btn-sm btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-target="#BarcodeLabelModal"
                  onClick={() => handlebarcodesheet()}
                >
                  Barcode Sheet
                </button>):(" ")}
                <BarcodeLabel />
              </div>
              )}

              {/* Excel Import Button */}
              {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 1643-1651
              <div className="p-2">
                <Link
                  className="btn btn-sm btn-secondary"
                  to={`/item-excel-import-count/${paramObject.id}`}
                >
                  Excel Import
                </Link>
              </div> */}
              {/* Search Button */}
              {/* <div className="p-2">
                <Link className="btn btn-info" to="#">
                  Search
                </Link>
              </div> */}
              {/* Search Text Field */}
              {/* <div className="p-2">
                <div className="col-md-12">
                  <input
                    type="search"
                    placeholder="Search By Item Name"
                    className="search-btn form-control"
                  />
                </div>
              </div>
              <div className="p-2">
                <input
                  type="date"
                  className="form-control"
                  id="EntryDate"
                  name="EntryDate"
                  onChange={(event, index) =>
                    handleChangeInput(event, index, "EntryDate")
                  }
                  // value={Moment(inventoryadjustment.AdjusmentDate).format(
                  //   "YYYY-MM-DD"
                  // )}
                />
              </div>

              <div className="p-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter No"
                    name="ReferenceNo"
                    // defaultValue={inventoryadjustment.Refrenceno}
                    onChange={(event, index) =>
                      handleChangeInput(event, index, "RefrenceNo")
                    }
                  />
                </div>
              </div> */}
            </div>
          </div>

          {/* Card for listing count inventory */}
          {checkStatus ? (
            <>
              <div className="card">
                {/* Card Header {Count Inventory} */}
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-6">
                      {/* <h5 className="fw-bold mt-3">New Inventory Count</h5> */}
                      <div className="col-md-12">
                        <div className="input-group flex-nowrap col-md-8">
                          <SearchableDropdown
                            callback={callback}
                            changeCount={changeCount}
                          />
                          {/* <Link className="btn btn-info" to="#">
                            Search
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : !paramObject.id ? (
            <div className="card">
              {/* Card Header {Count Inventory} */}
              <div className="card-header">
                <div className="row">
                  <div className="col-md-6">
                    {/* <h5 className="fw-bold mt-3">New Inventory Count</h5> */}
                    <div className="col-md-12">
                      <div className="input-group flex-nowrap col-md-8">
                        <SearchableDropdown
                          callback={callback}
                          changeCount={changeCount}
                        />
                        {/* <Link className="btn btn-info" to="#">
                          Search
                        </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="card">
            <div className="card-body">
              <table className="table table-striped custom-table">
                <thead>
                  <tr>
                    <th className="p-regular">No</th>
                    <th className="p-regular">Item Name</th>
                    <th className="p-regular">Count</th>
                    <th className="p-regular"> Quantity</th>
                    <th className="p-regular">Comment</th>
                    {checkUserPermission("show-cost-price") && (
                      <th className="p-regular">Cost</th>
                    )}
                    <th className="p-regular">Selling</th>
                    {checkUserPermission("show-cost-price") && (
                      <th className="p-regular">Total Cost</th>
                    )}
                    <th className="p-regular">Total Selling</th>
                    <th className="p-regular">Account</th>
                    <th className="p-regular">Supplier</th>
                    {checkStatus && <th className="p-regular">Delete</th>}
                  </tr>
                </thead>
                <tbody>
                  {stateNew?.map((data, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <td>{data.ItemId}</td>
                          {/* <td style={{width: "10%"}}>{data.VariationName}</td> */}
                          <td style={{ width: "166px", textWrap: "balance" }}>
                            {data?.VariationName == ""
                              ? data?.ItemName
                              : data?.VariationName}
                          </td>
                          <td className="col-md-1">
                            <input
                              type="number"
                              value={data.Counts}
                              onChange={(event) =>
                                handleCountChange(event, index)
                              }
                              className="form-control form-control-sm"
                              readOnly={
                                checkStatus === true
                                  ? null
                                  : !paramObject.id
                                  ? null
                                  : "readonly"
                              }
                            />
                          </td>
                          <td>
                            {parseFloat(
                              data.ActualOnHand
                                ? data.ActualOnHand
                                : data.ActualOnHand
                                ? data.ActualOnHand
                                : 0
                            )}
                          </td>
                          <td className="col-md-1">
                            <input
                              type="text"
                              defaultValue={data.Comments}
                              className="form-control form-control-sm"
                              onChange={(event) =>
                                handleCommentChange(event, index)
                              }
                              readOnly={
                                checkStatus === true
                                  ? null
                                  : !paramObject.id
                                  ? null
                                  : "readonly"
                              }
                            />
                          </td>
                          {checkUserPermission("show-cost-price") && (
                            <td>
                              {parseFloat(
                                data.CostPrice ? data.CostPrice : 0
                              ).toFixed(2)}
                            </td>
                          )}

                          <td>
                            {parseFloat(
                              data.UnitPrice ? data.UnitPrice : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            {parseFloat(
                              data.CostPrice * changeCount[index]
                                ? data.CostPrice * changeCount[index]
                                : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            {parseFloat(
                              data.UnitPrice * changeCount[index]
                                ? data.UnitPrice * changeCount[index]
                                : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            {data?.AccountId !== undefined &&
                              data?.AccountId !== 0 && (
                                <div className="text-danger text-danger-qb-sync-msg ">
                                  Inventory Quantity Adjustment
                                </div>
                              )}
                            <Select
                              className="z-index:2 custom-search-select"
                              options={depositToAccount}
                              value={depositToAccount?.filter(
                                (el) => el.value === data?.AccountId
                              )}
                              placeholder="Select an Account"
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="InventoryAdjusmentAccount"
                              name="InventoryAdjusmentAccount"
                              onChange={(event) =>
                                handleChangeInput(
                                  event,
                                  index,
                                  "InventoryAdjusmentAccount"
                                )
                              }
                            />
                          </td>
                          <td>
                            <Select
                              className="custom-search-select"
                              options={options}
                              value={options?.filter(
                                (el) => el.value === data?.SupplierId
                              )}
                              placeholder="Select a Supplier"
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="Supplier"
                              name="Supplier"
                              onChange={(event) =>
                                handleChangeInput(event, index, "Supplier")
                              }
                            />
                          </td>
                          {checkStatus && (
                            <td>
                              <Link
                                className="confirm-text"
                                to="#"
                                title="Delete"
                                // data-bs-toggle="modal"
                                // data-bs-target="#DeleteConfirmationModal"
                                onClick={() => handleDeletePopup(index)}
                              >
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                ></i>
                              </Link>
                            </td>
                          )}
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {/* {checkStatus && (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-info w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          )} */}
          {statusData == 3 ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-secondary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          ) : statusData == 2 ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
            </div>
          ) : !paramObject.id ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-secondary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* Delete Model  */}
      {/* <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/itemcountinventorydeletebyid`}
        open={deleteModalOpen}
        // quickbookarray={quickbookarray}
        onClose={() => setDeleteModalOpen(false)}
      /> */}
    </>
  );
};

export default NewInventoryCount;
